import React from 'react';
import injectSheet from 'react-jss';

import { layoutMaxWidth } from '../layouts/const.js';

const Divider = ({ classes }) => {
    return (
        <div className={classes.container}>
            <div className={classes.divider} />
        </div>
    );
};

const styles = {
    container: {
        maxWidth: ({ maxWidth = layoutMaxWidth }) => maxWidth,
        margin: '0 auto'
    },
    divider: {
        width: ({ width = '50%'}) => width,
        height: ({ stroke = 1}) => stroke,
        margin: '0 auto',
        backgroundColor: ({ color = 'black' }) => color
    }
};

export default injectSheet(styles)(Divider);



// WEBPACK FOOTER //
// ./src/components/Divider.js